import React, {useContext} from 'react';

import {useThemeType} from '@gravity-ui/uikit';

import {block} from '../../utils/cn';

import {StatusIllustrationContext} from './StatusIllustrationContext';
import {availableIllustrations} from './config';
import {IllustrationSizeMap, StatusIllustrationScope, StatusIllustrationStatus} from './types';

const b = block('status-illustration');

const DefaultSizeMap: IllustrationSizeMap = {
    s: 100,
    m: 150,
    l: 230,
    promo: 200,
};

export interface StatusIllustrationProps {
    status: StatusIllustrationStatus;
    size?: 's' | 'm' | 'l' | 'promo';
    entity?: string;

    className?: string;
    [prop: string]: unknown;
}

export const StatusIllustration = ({
    status,
    entity = 'generic/generic',
    size = 'l',

    className,
    ...props
}: StatusIllustrationProps) => {
    const [entityScope, entityName] = entity.split('/') as [StatusIllustrationScope, string];

    const {version, bucketUrl, sizeMap = DefaultSizeMap} = useContext(StatusIllustrationContext);

    const entityHasStatus = (
        entityScope: string,
        entityName: string,
        status: string,
        version: string,
    ): boolean => {
        // @ts-expect-error
        return availableIllustrations[entityScope]?.[entityName]?.[status]?.[version] ?? false;
    };

    if (!entityHasStatus(entityScope, entityName, status, version)) {
        entity = `generic/${entityName}`;

        if (!entityHasStatus('generic', entityName, status, version)) {
            entity = 'generic/generic';
        }
    }

    const theme = useThemeType();

    const src = `${bucketUrl}/${entity}/${status}/${'l'}/${theme}.svg`;

    const alt = status.replace(/-/g, ' ');

    const sizePx = sizeMap[size];

    return (
        <img
            className={b(null, className)}
            alt={alt}
            src={src}
            width={sizePx}
            height={sizePx}
            {...props}
        />
    );
};
